
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {ArraySection as ArraySectionObject} from "../lib/ArraySection";
    import Section from "@/lib/Section";
    import Question from "@/components/Question.vue";
    import {ArraySectionItem} from "../lib/ArraySectionItem";
    import Condition from "../lib/Condition";
    import store from "../store";

    @Component(
        {
            components: {
                Question
            },
        },
    )
    export default class ArraySection extends Vue {
        @Prop() public section: Section;

        created() {
            this.section.createArraySection();
        }

        initConditions() {
            let count = 0;
            this.section.arraySection.arraySectionItems.forEach((section: ArraySectionItem) => {
                section.additional.updateLabel();
                section.conditions.forEach((condition: Condition) => {
                    condition.check();
                    console.log(condition);
                    console.log(condition.isFulfilled)
                });
                count++;
            });
        }

        mounted() {
            this.initConditions();
        }

    }
